export const tribeAccount = () => {
    const $tribeAccount = document.querySelector(".tribe-account");

    if ($tribeAccount) {
        const $wrapperMain = $tribeAccount.querySelector(".tribe-account__wrapper.tribe-account__wrapper--main");
        const $wrapperProfile = $tribeAccount.querySelector(".tribe-account__wrapper.tribe-account__wrapper--profile");

        if ($wrapperMain && $wrapperProfile) {
            
            const $accountLinks = $wrapperMain.querySelector(".tribe-account__links");
            const $backOverView = $wrapperProfile.querySelector(".tribe-account__back");
            const $backProfile = $wrapperProfile.querySelector(".tribe-account__back.tribe-account__back--profile");
            const $wrapperGrid = $wrapperProfile.querySelector(".wrapper__grid");

            if ($accountLinks && $backOverView && $backProfile && $wrapperGrid) {

                const $gridLinks = $wrapperGrid.querySelector(".grid__links");
                const $accountLinkProfile = $accountLinks.querySelector(".item__link.item__link--profile");
                const $gridContents = $wrapperGrid.querySelector(".grid__contents");

                if ($gridLinks && $accountLinkProfile && $gridContents) {

                    const $gridLinkDetails = $gridLinks.querySelector(".grid__link.grid__link--details");
                    const $gridLinkAddresses = $gridLinks.querySelector(".grid__link.grid__link--addresses");
                    const $gridContentDetails = $gridContents.querySelector(".grid__content.grid__content--details");
                    const $gridContentResetPasswod = $gridContents.querySelector(".grid__content.grid__content--reset-password");
                    
                    //wrapped behind "unless" - dont test for until it's needed
                    const $gridLinkResetPassword = $gridLinks.querySelector(".grid__link.grid__link--reset-password");

                    if ($gridLinkDetails && $gridLinkAddresses && $gridContentResetPasswod && $gridContentDetails) {
                        
                        const $gridContentsDetailsSvg = $gridLinks.querySelector('.grid__link--details svg');
                        const $gridLinkResetPasswordSvg = $gridLinks.querySelector('.grid__link--reset-password svg'); 

                        // Show the My Details tab contents
                        const showGridContentDetails = () => {
                            
                            $gridContentResetPasswod.classList.remove("flex");
                            $gridContentResetPasswod.classList.add("hidden");

                            $gridContentDetails.classList.add("flex");
                            $gridContentDetails.classList.remove("hidden");

                            $gridContents.classList.remove("hidden");
                            $gridContents.classList.add("flex");

                            $gridLinks.classList.add("hidden");
                            $gridLinks.classList.remove("flex");

                            $backOverView.classList.remove("flex");
                            $backOverView.classList.add("hidden");

                            $backProfile.classList.remove("hidden");
                            $backProfile.classList.add("flex");

                            if ($gridContentsDetailsSvg) {
                                $gridContentsDetailsSvg.classList.add('desktop:flex');
                                $gridContentsDetailsSvg.classList.remove('desktop:hidden');
                            }

                            if ($gridLinkResetPasswordSvg) {
                                $gridLinkResetPasswordSvg.classList.add('desktop:hidden');
                                $gridLinkResetPasswordSvg.classList.remove('desktop:flex');   
                            }
                        };

                        // Show the Reset Password tab contents
                        const showGridContentResetPassword = () => {
                            $gridContentResetPasswod.classList.add("flex");
                            $gridContentResetPasswod.classList.remove("hidden");

                            $gridContentDetails.classList.add("hidden");
                            $gridContentDetails.classList.remove("flex");

                            $gridContents.classList.remove("hidden");
                            $gridContents.classList.add("flex");

                            $gridLinks.classList.add("hidden");
                            $gridLinks.classList.remove("flex");

                            $backOverView.classList.remove("flex");
                            $backOverView.classList.add("hidden");

                            $backProfile.classList.remove("hidden");
                            $backProfile.classList.add("flex");

                            if ($gridContentsDetailsSvg) {
                                $gridContentsDetailsSvg.classList.remove('desktop:flex');
                                $gridContentsDetailsSvg.classList.add('desktop:hidden');
                            }

                            if ($gridLinkResetPasswordSvg) {
                                $gridLinkResetPasswordSvg.classList.remove('desktop:hidden');
                                $gridLinkResetPasswordSvg.classList.add('desktop:flex');   
                            }
                        }


                        // Show the Main Page contents
                        const showMain = () => {

                            $wrapperMain.classList.add("flex");
                            $wrapperMain.classList.remove("hidden");

                            $wrapperProfile.classList.remove("flex");
                            $wrapperProfile.classList.add("hidden");

                            $backProfile.classList.add("hidden");
                            $backProfile.classList.remove("flex");

                            $backOverView.classList.add("hidden");
                            $backOverView.classList.remove("flex");

                            $gridLinks.classList.add("hidden");
                            $gridLinks.classList.remove("flex");

                            $gridContents.classList.remove("hidden");
                            $gridContents.classList.add("flex");
                        };

                        const showProfile = () => {
                            $wrapperMain.classList.remove("flex");
                            $wrapperMain.classList.add("hidden");

                            $wrapperProfile.classList.add("flex");
                            $wrapperProfile.classList.remove("hidden");

                            $backProfile.classList.remove("hidden");
                            $backProfile.classList.add("flex");
                            
                            if (window.innerWidth > 1023) {
                                $backOverView.classList.remove("hidden");
                                $backOverView.classList.add("flex");
                            }
                        };

                        //Clicked on "My Profile"
                        $accountLinkProfile.addEventListener("click", (event) => {
                            event.preventDefault();
                            showProfile();
                            showGridContentDetails();
                        });

                        //When viewing profile data on a phone, clicked the "Back to my Profile" button
                        $backProfile.addEventListener("click", (event) => {
                            event.preventDefault();
                            $backProfile.classList.remove("flex");
                            $backProfile.classList.add("hidden");

                            $backOverView.classList.add("flex");
                            $backOverView.classList.remove("hidden");

                            $gridLinks.classList.remove("hidden");
                            $gridLinks.classList.add("flex");

                            $gridContents.classList.add("hidden");
                            $gridContents.classList.remove("flex");
                        });

                        //Clicked on Back to Overview Button       
                        $backOverView.addEventListener("click", (event) => {
                            event.preventDefault();
                            showMain();
                        });

                        //Clicked on the "My details" tab
                        $gridLinkDetails.addEventListener("click", (event) => {
                            event.preventDefault();

                            showGridContentDetails();
                        });


                        //Clicked on "Reset Password" tab
                        $gridLinkResetPassword.addEventListener("click", (event) => {
                            event.preventDefault();
                            showGridContentResetPassword();
                            showProfile();
                        });

                        const url = new URL(window.location);
                        
                        if (url.hash === "#details") {                        
                            showGridContentDetails();
                            showProfile();                    
                        } else if (url.hash === "#reset-password") {
                            showGridContentResetPassword();
                            showProfile();
                        }                        
                    }
                }
            }
        }
    }
}

export default tribeAccount;